import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const SpendPerDayCard = ({ spendPerDay, budgetedSpendPerDay }) => {
  const theme = useTheme();
  const isOverBudget = spendPerDay > budgetedSpendPerDay;
  const valueColor = isOverBudget ? theme.palette.overage.main : theme.palette.text.primary;

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return `$${val.toFixed(2)}`;
    }
    return val;
  };

  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" color="text.secondary">
        Spend Per Day
      </Typography>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="h4" style={{ color: valueColor }}>
          {formatValue(spendPerDay)}
        </Typography>
      </Box>
       <Typography variant="subtitle2" color="text.secondary">
          Budgeted: {formatValue(budgetedSpendPerDay)}
       </Typography>
    </Paper>
  );
};

export default SpendPerDayCard;